import { H6 } from 'foundations-components/transitional/components/H6';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getLanguageNameFromCode } from '../../utils/langUtils';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TemplateEditorSidebarAlert({
  masterLanguage,
  selectedLanguage,
  handleTranslateClick
}) {
  return /*#__PURE__*/_jsxs(Alert, {
    marginBlockEnd: "300",
    marginInline: "500",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.templateEditor.sidebar.alert.title",
      options: {
        primaryLanguage: getLanguageNameFromCode(masterLanguage)
      }
    }),
    type: "warning",
    use: "inline",
    children: [/*#__PURE__*/_jsxs(View, {
      marginBlockStart: "500",
      marginBlockEnd: "100",
      children: [/*#__PURE__*/_jsx(H6, {
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.templateEditor.sidebar.alert.contentHeader"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.templateEditor.sidebar.alert.content",
          options: {
            selectedLanguage: getLanguageNameFromCode(selectedLanguage)
          }
        })
      })]
    }), /*#__PURE__*/_jsx(Button, {
      use: "tertiary",
      size: "small",
      onClick: handleTranslateClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.sidebar.translation.editButton"
      })
    })]
  });
}